export const BOOK_WITH_HOTEL_PROVIDER_CODES = new Set([
  'BOO',
  'FSB',
  'TCK',
  'DYS',
  'FBD',
  'MIR',
  'MHS',
  'NOZ',
  'PHO',
  'SAB'
])
export const BOFH_PROVIDER_CODES = new Set([
  'FHT',
  'GAR',
  'HBD',
  'EAN',
  'EPS',
  'PPN',
  'WBD',
  'SMR',
  'BTL',
  'FPH',
  'NTE',
  'WTM',
  'OLY',
  'HTR',
  'GOG'
])

export const DEFAULT_PROVIDER_NAME = 'Vio.com'
export const DEFAULT_PROVIDER_CODE = 'VIO'
export const VIO_PROVIDER_NAME = 'Vio.com'
export const VIO_PROVIDER_CODE = 'VIO'

export const isBookWithHotelProvider = (providerCode = ''): boolean => {
  const code = providerCode.toUpperCase()
  return BOOK_WITH_HOTEL_PROVIDER_CODES.has(code)
}

export const providersMap = {
  ACC: 'Accor',
  AGD: 'Agoda',
  BKS: 'Booking.com',
  BOO: 'Revato',
  BWS: 'BestWestern',
  CTE: 'Trip.com',
  DES: 'Destinia',
  DRR: 'Drury',
  EBK: 'ebookers.com',
  EBX: 'ebookers.com',
  EXP: 'Expedia.com',
  HDE: 'hotel.de',
  HOA: 'Hotelopia',
  HOW: 'Hostelworld',
  HRS: 'hotel.de',
  IAN: 'Hotels.com',
  ORB: 'Orbitz',
  OYO: 'Oyorooms',
  PLN: 'Priceline',
  RDI: 'Roomdi.com',
  SBO: 'Sembo',
  SFL: 'Stayforlong',
  TCY: 'Travelocity',
  TRO: 'Algotels',
  VIO: 'Vio.com',
  WTF: 'Wotif',
  ZHT: 'zenhotels'
} as const

type ProvidersMap = typeof providersMap
export type ProvidersMapKeys = keyof ProvidersMap
export type ProvidersMapValues = ProvidersMap[keyof ProvidersMap]

export const getBofhCode = (): string => {
  return VIO_PROVIDER_CODE.toLowerCase()
}

export const getProviderName = (providerCode: string): string => {
  const code = providerCode.toUpperCase()

  return BOFH_PROVIDER_CODES.has(code)
    ? VIO_PROVIDER_NAME
    : providersMap[code as Uppercase<ProvidersMapKeys>]
}

export const getProviderIcon = ({
  providerCode,
  iconsUrlPrefix
}: {
  providerCode: string
  iconsUrlPrefix: string
}): string => {
  const upperCaseCode = providerCode.toUpperCase()

  const lowerCaseCode = BOFH_PROVIDER_CODES.has(upperCaseCode)
    ? getBofhCode()
    : upperCaseCode.toLowerCase()

  return iconsUrlPrefix + `/svg/${lowerCaseCode}--icon.svg`
}

export const getBookWithHotelIcon = (iconsUrlPrefix: string): string =>
  getProviderIcon({providerCode: 'boo', iconsUrlPrefix})

export const getSvgProviderLogo = (
  providerCode: string,
  iconsUrlPrefix: string
): string => {
  const upperCaseCode = providerCode.toUpperCase()

  const lowerCaseCode = BOFH_PROVIDER_CODES.has(upperCaseCode)
    ? getBofhCode()
    : upperCaseCode.toLowerCase()

  return iconsUrlPrefix + `/svg/${lowerCaseCode}.svg`
}
